import Link from "next/link"
import { isFilled } from "@prismicio/client"
import { PrismicNextImage } from "@prismicio/next"
import type { ImageField, KeyTextField } from "@prismicio/client"

type SiteLogoProps = {
  image: ImageField
  title?: KeyTextField
  subtitle?: KeyTextField
  variant?: "header" | "footer"
}

export const SiteLogo = ({
  image,
  title,
  subtitle,
  variant = "header",
}: SiteLogoProps) => (
  <Link
    href="/"
    className="flex items-center gap-4 no-underline hover:no-underline"
  >
    {isFilled.image(image) && (
      <div
        className={`overflow-hidden rounded-full p-2 ring-2 ${variant === "header" ? "ring-amber-200" : "ring-white/30"}`}
      >
        <PrismicNextImage
          field={image}
          width={52}
          height={52}
          className="size-14 rounded-full object-cover md:size-16 xl:size-20"
          fallbackAlt=""
          imgixParams={{ auto: ["format", "compress"], q: 75 }}
        />
      </div>
    )}
    <div className="flex flex-1 flex-col leading-none">
      {isFilled.keyText(title) && (
        <span
          className={`text-base font-bold sm:text-sm md:text-md lg:text-lg xl:text-xl ${variant === "footer" ? "text-white" : "text-amber-800"}`}
        >
          {title}
        </span>
      )}
      {isFilled.keyText(subtitle) && (
        <span
          className={`text-base md:text-sm xl:text-md ${variant === "footer" ? "font-medium text-white/80" : "font-medium text-amber-600"}`}
        >
          {subtitle}
        </span>
      )}
    </div>
  </Link>
)
